import React from 'react';

function CustomerSupport() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Support</h1>
        <p className="subtitle">Get help with your account</p>
      </div>
      <div className="empty-state">
        <p>Support center coming soon!</p>
      </div>
    </div>
  );
}

export default CustomerSupport;
